import { notInPlanMessage } from "@utils/planFeatures";

export const EntitlementBanner = () => (
  <div className="alert alert-warning m-3" role="alert">
    {notInPlanMessage("workflow-approval")}
  </div>
);
